/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.text {
  color: var(--color-emphasis-high, #000);
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--text-xl, 1.25rem);
  line-height: var(--tw-leading, var(--text-xl--line-height, calc(1.75 / 1.25)));
  display: flex;
  align-items: center;
  gap: calc(var(--spacing, 0.25rem) * 2);
}
.h4 {
  margin: 0px;
  display: flex;
  gap: calc(var(--spacing, 0.25rem) * 4);
  align-items: center;
}
.link {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  color: var(--color-primary-500);
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
